import type { NextRequest } from "@/modules/fetch/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

type getSeenJobAdsParams = {
  nextRequest?: NextRequest
}

const API_ENDPOINT_PATH = `/v2alpha2/jobads/seen`

export const getSeenJobAds = async (params: getSeenJobAdsParams = {}): Promise<string[]> => {
  const { nextRequest } = params

  return fetcher(API_ENDPOINT_PATH, {
    nextRequest,
    serviceDomain: "KRAKEND_API",
  })
    .then(getResultFromResponse<{ seen_job_ad_ids: string[] }>())
    .then(data => data.seen_job_ad_ids)
    .catch(handleFetchError(API_ENDPOINT_PATH))
    .catch(() => [])
}
